import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Grid } from 'react-bootstrap';
import PageTitle from '../../../common/page-title';
import PrizesList from './prizes-list';
import PrizesSearch from './prize-search';
import { getPrizes, deletePrize } from '../../../../actions/prizes';
import ArrowButton from '../../../common/button-arrow';

class Prizes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      pageNumber: 1
    };
  }

  componentWillMount() {
    this.loadPrizes();
  }

  loadPrizes = () => {
    this.props.dispatch(getPrizes(this.state.pageNumber, this.state.query));
  };

  handleSearch = () => {
    this.props.dispatch(getPrizes(1, this.state.query));
  };

  handleInputChange = (input) => {
    this.setState({ ...this.state, query: input.target.value });
  };

  handleClear = () => {
    this.setState(
      {
        query: '',
        pageNumber: 1
      },
      this.loadPrizes
    );
  };

  handlePageChange = (page) => {
    this.setState({ ...this.state, pageNumber: page }, this.loadPrizes);
  };

  handleDelete = (id) => {
    if (id) {
      this.props.dispatch(deletePrize(id)).then(() => {
        this.props.dispatch(getPrizes(this.state.pageNumber, this.state.query));
      });
    }
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="users">
        <PageTitle>Prizes</PageTitle>
        <Link to="/admin/prizes/new">
          <ArrowButton
            submit={false}
            arrow={false}
            className="add-prize"
            permissions={{
              action: 'manage',
              subjectClass: 'StaffRewardSetting'
            }}
          >
            Add prize
          </ArrowButton>
        </Link>
        <PrizesSearch
          onSearch={this.handleSearch}
          onInputChange={this.handleInputChange}
          onClear={this.handleClear}
          searchValue={this.state.query}
        />
        <PrizesList
          prizes={this.props.prizes}
          fetching={this.props.fetching}
          fetched={this.props.fetched}
          currentPage={this.state.pageNumber}
          onPageChange={this.handlePageChange}
          onDelete={this.handleDelete}
          paging={this.props.paging}
        />
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    prizes: state.prizes.prizes,
    fetched: state.prizes.fetched,
    fetching: state.prizes.fetching,
    paging: state.prizes.paging
  };
};

export default connect(mapStateToProps)(Prizes);



// WEBPACK FOOTER //
// ./src/components/admin/prizes/list/index.js